export default class SnippetStore {
  selectedWaveform1key;
  selectedWaveform2key;
  seconds;
  markers = [];
  startPosition = { x: 0, y: 0 };
  endPosition = { x: 0, y: 0 };
  boundaries;
  diagnoses = [];
  marchout = false;
  selectedDiagnoses = [];
  controlsExpanded;
}

export function resetSnippet(store) {
  const blankSnippet = new SnippetStore();
  Object.assign(store, blankSnippet);
}
